
import bootLayout from 'static/script/app/boot/boot-layout';
import DeferLoad from 'static/script/app/ui/defer-load';
import RecentlyViewedItems from 'static/script/app/ui/recently-viewed-items';
import MegaCategories from 'static/script/app/ui/mega-categories';
import CarouselUI from 'static/script/app/ui/carousel-ui';
import LastChanceUI from 'static/script/app/ui/last-chance-ui';
import WishListUIList from 'static/script/app/ui/wish-list-ui-for-list';
import WishListService from 'static/script/app/data/wish-list-service';
import LastChanceService from 'static/script/app/data/last-chance-service';
import isHybridApp from 'static/script/utils/is-hybrid-app';
import NativeAppBetaSignupTriggerUI from 'static/script/app/ui/beta-signup/native-app-beta-signup-trigger-ui';
import logger from 'logger';

module.exports = initData => {
    bootLayout(initData);
    //DeferLoad.attachTo('[data-defer-load]');
    DeferLoad.attachTo(document);
    RecentlyViewedItems.attachTo('[data-recently-viewed-items]');
    MegaCategories.attachTo('[data-start-page-mega-categories]');
    CarouselUI.attachTo('[data-carousel]');
    LastChanceService.attachTo(document); // Load before LastChanceUI
    LastChanceUI.attachTo('[data-startpage-lazy-load-last-chance]', { initData: initData });

    /**
     * Define code split
     */
    if (initData.splitTests['marketing-automation-recommendations']) {
        System.import('app/marketing-automation/index' /* webpackChunkName = "product-recs" */)
        .then(module => module(initData))
        .catch(error => logger(error));
    };

    if (isHybridApp()) {
        NativeAppBetaSignupTriggerUI.attachTo(document);
    }
}


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/start-page.js